<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import "../static/fonts/materialIcon.css";
@import "../static/fonts/font-awesome-4.7.0/css/font-awesome.min.css";
@import "../static/fonts/smc-icon/smc-icon.css";
@import "../static/scss/material-kit.scss";
</style>




// WEBPACK FOOTER //
// src/App.vue